import React from 'react';
import PropTypes from 'prop-types';
import './WidgetButton.css';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
  root: {
    '& svg': {
      width: theme.customStyles.widgetButtonsSvg.width
    },
    fontSize: '1rem'
  },
  style: {
    background: theme.palette.grey.medium,
    borderRadius: theme.customStyles.widgetButtons.borderRadius,
    padding: theme.customStyles.widgetButtons.padding,
    marginLeft: theme.customStyles.widgetButtons.marginLeft
  }
}));

const WidgetButton = ({ children, onClick }) => {
  const classes = useStyles();

  return (
    <IconButton onClick={onClick} classes={{ root: classes.root }} className={classes.style}>
      {children}
    </IconButton>
  );
};

WidgetButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default WidgetButton;
